import { TopNav, BottomNav } from "./AppNav/index"

const AppNav = () => {
  return (
    <nav className="sticky top-0 z-50">
      <TopNav />
      <BottomNav />
    </nav>
  )
}

export default AppNav
